import React from 'react';
import { Box, Typography } from '@mui/material';

const NoDataOverlay = () => {
  return (
    <Box className="common-data-grid-no-data-overlay">
      <Typography variant="body2" component="div">
        <h3>No records found</h3>
      </Typography>
    </Box>
  );
};

export default NoDataOverlay;
